/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('ArticleRelationPriceFactory', function($resource) {
	return $resource(
		'api/articleRelationPrices/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewArticleRelationPriceFactory', function($resource) {
	return $resource(
		'api/articleRelationPrices/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all ArticleRelationPrices without the use of paging
angular.module('emsApp').factory('NoPagingArticleRelationPriceFactory', function($resource) {
	return $resource(
		'api/articleRelationPrices/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllArticleRelationPricesByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/articleRelationPrices/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});
